import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function AnnouncementBar() {
  return <div className="bg-orange text-white py-2 px-4 text-xs md:text-sm font-medium sticky top-0 z-50 w-full shadow-md" data-id="element-1">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-2">
        <div className="flex-1" data-id="element-3"></div>
        <span className="flex items-center text-center font-bold" data-id="element-4">
          💫 Últimos momentos de oferta 💫
        </span>
        <div className="flex-1 flex justify-end" data-id="element-5">
          <CountdownTimer minutes={17} showIcon={true} data-id="element-6" />
        </div>
      </div>
    </div>;
}